var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "defective-box" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTab },
          model: {
            value: _vm.tabName,
            callback: function($$v) {
              _vm.tabName = $$v
            },
            expression: "tabName"
          }
        },
        [
          _c("el-tab-pane", { attrs: { label: "次品组", name: "group" } }),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "次品员", name: "member" } })
        ],
        1
      ),
      _vm._v(" "),
      _vm.tabName == "group" ? _c("div", [_c("group")], 1) : _vm._e(),
      _vm._v(" "),
      _vm.tabName == "member" ? _c("div", [_c("member")], 1) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-935133c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-935133c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/defectivegroup/index.vue
// module id = null
// module chunks = 